import { useState } from "react";
import * as api from "apis/FusionAPI";
import MANUAL_ROAD_CLOSURE_MBTN from "assets/roadclosure.png";
import TECHNOLOGY_BRIDGE_SIREN_MBTN from "assets/siren.png";

export const useDeviceActions = (
  selectedDevices,
  setSelectedDevices,
  userDevicesOriginal,
  setUserDevicesOriginal
) => {
  const [saveSuccess, setSaveSuccess] = useState(false);

  const getBasicDeviceIcon = (device) => {
    if (device.device_type === "Manual Road Closure") {
      return MANUAL_ROAD_CLOSURE_MBTN;
    } else if (device.device_type === "Technology Bridge_Siren/Giant Voice") {
      return TECHNOLOGY_BRIDGE_SIREN_MBTN;
    } else if (device.device_type === "Technology Bridge_Flashing Lights") {
      return MANUAL_ROAD_CLOSURE_MBTN;
    }
  };

  const toggleDevice = async (device, type) => {
    // If device.group_Data exists, handle all groups for this device
    const groupIds = device.group_Data
      ? [...new Set(device.group_Data.map((g) => g.id))]
      : [];

    let found = selectedDevices.find(
      (d) =>
        d.id === device.id &&
        d.node_id === device.node_id &&
        d.alias === device.alias &&
        d.workplace_id === device.workplace_id
    );

    let newSelectedDevices;
    if (!found) {
      // Add device with all group ids
      newSelectedDevices = [
        ...selectedDevices,
        {
          id: device.id,
          alias: device.alias,
          node_id: device.node_id,
          workplace_id: device.workplace_id,
          pushEnabled: type === "push" ? 1 : 0,
          emailEnabled: type === "email" ? 1 : 0,
          group_id: groupIds.length > 0 ? groupIds : null,
        },
      ];
    } else {
      // Update device: toggle notification and update group_id (unique)
      newSelectedDevices = selectedDevices.map((d) => {
        if (
          d.id === device.id &&
          d.node_id === device.node_id &&
          d.alias === device.alias &&
          d.workplace_id === device.workplace_id
        ) {
          // Merge group ids, ensure uniqueness
          const mergedGroupIds = [...(d.group_id || []), ...groupIds].filter(
            Boolean
          );
          const uniqueGroupIds = [...new Set(mergedGroupIds)];
          return {
            ...d,
            pushEnabled:
              type === "push" ? (d.pushEnabled === 0 ? 1 : 0) : d.pushEnabled,
            emailEnabled:
              type === "email"
                ? d.emailEnabled === 0
                  ? 1
                  : 0
                : d.emailEnabled,
            group_id: uniqueGroupIds.length > 0 ? uniqueGroupIds : null,
          };
        }
        return d;
      });
    }

    setSelectedDevices(newSelectedDevices);
  };

  const discardChanges = () => {
    setSelectedDevices(userDevicesOriginal);
  };

  const handleSave = async () => {
    let res;

    const diff = selectedDevices.filter(
      (d) =>
        !userDevicesOriginal.find(
          (d2) =>
            d.id === d2.id &&
            d.node_id === d2.node_id &&
            d.alias === d2.alias &&
            d.workplace_id === d2.workplace_id
        ) ||
        d.pushEnabled !==
          userDevicesOriginal.find(
            (d2) =>
              d.id === d2.id &&
              d.node_id === d2.node_id &&
              d.alias === d2.alias &&
              d.workplace_id === d2.workplace_id
          ).pushEnabled ||
        d.emailEnabled !==
          userDevicesOriginal.find(
            (d2) =>
              d.id === d2.id &&
              d.node_id === d2.node_id &&
              d.alias === d2.alias &&
              d.workplace_id === d2.workplace_id
          ).emailEnabled
    );
    console.log("diff", diff);

    if (diff.length < 1) {
      console.log("no changes");
      return;
    }

    // Transform the data to match the new API format
    const transformedDiff = diff.map((device) => ({
      id: device.id,
      node_id: device.node_id,
      alias: device.alias,
      workplace_id: device.workplace_id,
      pushEnabled: device.pushEnabled,
      emailEnabled: device.emailEnabled,
      group_id: device.group_id, // This will be an array or null
    }));

    console.log("Transformed diff for API:", transformedDiff);

    res = await api.updateSubscribedDevices(transformedDiff);

    if (res.status === 200) {
      const res2 = await api.getSubscribedDevices();
      console.log("res2", res2);
      if (res2.status === 200) {
        setSelectedDevices(res2.data.subscriptions);
        setUserDevicesOriginal(res2.data.subscriptions);
        setSaveSuccess(true);
        setTimeout(() => {
          setSaveSuccess(false);
        }, 5000);
      }
    } else {
      alert("Failed to update subscriptions");
    }

    return;
  };

  return {
    getBasicDeviceIcon,
    toggleDevice,
    discardChanges,
    handleSave,
    saveSuccess,
  };
};
